export default __webpack_public_path__ + "static/media/gallery36.441b9c31.jpg";